import { camelize, isPlainObject } from 'vessel/utils'

export default class GraphqlBase {
  constructor({ path, root, parser, clientId, headers, locale, tenant, fragment, ...options }) {
    this.path     = path
    this.root     = root
    this.parser   = parser
    this.clientId = clientId
    this.headers  = headers
    this.locale   = locale
    this.tenant   = tenant
    this.fragment = fragment
    this.options  = options
  }

  get client() {
    const client = this.clientId || (this.path.includes('/') ? this.path.split('/')[0] : null)
    return client == 'main' ? 'default' : client
  }

  get config() {
    const name   = this.path.split('/').pop()
    const plural = name.endsWith('y') ? name.replace(/y$/, 'ies') : `${name}s`

    return {
      name: camelize(name, 'upper'),
      pluralName: camelize(plural, 'upper'),
      slug: camelize(name, 'lower'),
      pluralSlug: camelize(plural, 'lower')
    }
  }

  get fragments() {
    try {
      return require(`@/graphql/${this.path}`)
    } catch (e) {
      return {}
    }
  }

  get definition() {
    if (isPlainObject(this.file)) {
      return this.file
    }

    try {
      const file = this.generator.call(null, this.file, this.config, this.fragments, this.fragment)
      if (!file) console.error(`GraphQL Error: File ${this.file} in ${this.path} missing!`)

      return file
    } catch (e) {
      console.error(`GraphQL Error: Generation for ${this.path} failed!`, this.config)
      return {}
    }
  }

  get context() {
    const { headers, locale, tenant } = this
    const object = { ...headers }

    if (locale) object['Locale'] = locale
    if (tenant) object['Tenant'] = tenant

    return { headers: object }
  }

  parseResult() {
    return {}
  }

  async execute() {
    return this.parseResult()
  }

  update(context, result) {
    const object = this.parseResult(result)
    Object.keys(object).forEach(key => context[key] = object[key])
  }
}
